import { NgModule } from '@angular/core';
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { IconsModule } from "@progress/kendo-angular-icons";
import { ScrollViewModule } from "@progress/kendo-angular-scrollview";
import { MenusModule } from "@progress/kendo-angular-menu";
import { NotificationModule } from "@progress/kendo-angular-notification";
import { ProgressBarModule } from "@progress/kendo-angular-progressbar";
import { ChartsModule } from '@progress/kendo-angular-charts';
import { FormsModule } from '@angular/forms';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { LabelModule } from '@progress/kendo-angular-label';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { GridModule } from '@progress/kendo-angular-grid';
import { WindowModule } from "@progress/kendo-angular-dialog";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { UploadsModule } from "@progress/kendo-angular-upload";

const modules: any[] = [
  DropDownsModule,
  DateInputsModule,
  ButtonsModule,
  InputsModule,
  IconsModule,
  ScrollViewModule,
  MenusModule,
  NotificationModule,
  ProgressBarModule,
  ChartsModule,
  FormsModule,
  IndicatorsModule,
  SchedulerModule,
  LayoutModule,
  TooltipModule,
  LabelModule,
  GridModule,
  WindowModule,
  ListViewModule,
  DialogsModule,
  UploadsModule,
]

@NgModule({
  exports: modules
})
export class KendoModule { }
